import { select } from '../shared/utils/dom';
import { delimiters } from '../shared/constants';
import loadingMixin from '../shared/vue/mixins/loading';
import scrollUp from '../shared/vue/mixins/scrollUp';
import accountLookup from '../shared/vue/mixins/accountLookup';
import { createAccount, getErrorMessages } from './api';
import { createError, removeError } from '../shared/formErrors';
import { regex } from '../shared/constants/validation';
import dataLayerPush from '../shared/utils/analytics';

// re-assign some API methods
const { getSecondaryLookupField, verifyAccountOwnership } = createAccount; // eslint-disable-line no-unused-vars
/*
* Forgot password form
*/
const el = select('[data-vue-app="forgot-password"]');
if (el) {
  const app = new Vue({ // eslint-disable-line no-unused-vars
    el,
    mixins: [loadingMixin, scrollUp, accountLookup],
    delimiters,
    data: {
      // for accessibility in live regions
      liveText: '',
      success: false,
      emailForPassword: '',
      // the verification button disabled by default
      enableResetButton: false,
      enableSubmitButton: false,
      isReady: false,
      hasError: false,
      errorMessages: getErrorMessages(),
      showLinkToRegister: false,
      modelValidationResults: [],
      prevalidation: {},
    },
    /**
     * Methods
     */
    methods: {
      /**
       * Check to make sure the email address that was entered is valid before account lookup happens
       */
      checkIfValidEmail() {
        if (!this.emailForPassword) {
          createError(this.$refs.emailForPassword, this.$refs.emailForPasswordError, 'Please provide an email address.');
          this.hasError = true;
        } else if (!regex.email.test(this.$refs.emailForPassword.value)) {
          createError(this.$refs.emailForPassword, this.$refs.emailForPasswordError, 'Please provide a valid email address.');
          this.hasError = true;
        } else {
          removeError(this.$refs.emailForPassword, this.$refs.emailForPasswordError);
          this.hasError = false;
          this.enableSubmitButton = true;
        }

        if (this.hasError) {
          this.liveText = 'Please provide a valid email address.';
          this.enableSubmitButton = false;
        }
      },
      sendToken() {
        this.loading = true;
        const request = {
          username: this.emailForPassword,
          ldc: this.modelLdc,
          licenseKey: '123456',
          customerAccountId: this.unmaskedAccountNumber,
          phoneNumber: this.unmaskedPhoneNumber,
        };
        createAccount.sendPasswordResetToken(request)
          .then(() => {
            this.loading = false;
            this.success = true;
            dataLayerPush('ForgotPassword');
          })
          .catch((err) => {
            // Replace WSS links in error messages
            select('#page-alerts').innerHTML = select('#page-alerts').innerHTML.replace(/{legacy_link}/gi, `<a href="/wss/${this.modelLdc}">the old system</a>`);
            this.success = false;
            this.loading = false;

            // if legacy user, hide the forgot password form and show button for user to create account
            // the show link to register button with have a submit method as well that will take the user there
            if (err.response.data.error.code === 2038) {
              this.showLinkToRegister = true;
            }
          });
      },

      submitLegacyForm() {
        // submit hidden form
        document.querySelector("#legacy-account").submit();
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/forgotPassword.js